export default "__VITE_ASSET__DNsrtVIK__"